<div class="auditItem Processing-Done-Category">
  <div class="auditIconWrap">
    <div class="auditBadgeIcon"></div>
    <div class="auditIcon" title="Processing-Done" matTooltipClass="auditTooltip"
      [matTooltip]="processingDone?.operator?.id != processingDone?.finalOwner?.id ? 'Operazione effettuata da ' +  processingDone?.operator?.displayName : ''"
      matTooltipPosition="after"
      [ngClass]="processingDone?.operator?.id != processingDone?.finalOwner?.id ? 'operatedByOthers' : ''">
    </div>
  </div>
  <div class="auditInfo">
    <div class="auditHeader"><span class="auditTimestamp">{{processingDone?.updated |  formatDateWithTimezone | async}}</span>
      <span (click)="isSelected ? unselected.emit() : selected.emit()" class="showAuditDetails">
        <mat-icon>info</mat-icon>
      </span></div>
    <div class="auditDescription">
      <p>
        <ng-container *ngIf="processingDone?.operator?.id">
          Qualificato da <strong>{{processingDone?.operator?.displayName}}</strong>
        </ng-container>
        <ng-container *ngIf="!processingDone?.operator?.id">
          Qualificato dal sistema
        </ng-container>
        come <strong>{{ 'enums.qualificationOutcome.' + processingDone?.qualificationOutcome | translate}}</strong>.
      </p>
    </div>
    <div class="auditCommentWrap">

      <div class="auditCommentText">
        <p>
          {{processingDone?.comment}}
        </p>
      </div>
    </div>
  </div>
</div>
